import React from "react";
import { PublicSpinWheelContent } from "./PublicSpinWheelContent";

export default function PublicSpinWheel() {
  return (
    <div className="h-screen bg-gradient-to-b from-[#ecfeff] via-[#e0f2fe] to-[#f5f3ff] px-4 py-10 overflow-y-auto">
      <div className="w-full space-y-6">
        <div className="text-center space-y-2 mb-4">
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 drop-shadow-sm">
            Spin the Wheel. <span className="text-emerald-500">Instant Rewards.</span>
          </h1>
          <p className="text-sm md:text-base text-slate-600 max-w-2xl mx-auto">
            Drop in your mobile number and hit{" "}
            <span className="font-semibold text-emerald-400">Engage</span> to take a
            lucky spin. Every turn is a fresh chance to score surprise bonus points.
          </p>
        </div>

        <div className="bg-gradient-to-br from-white via-[#f1f5f9] to-[#e0f2fe] backdrop-blur-sm shadow-[0_18px_45px_rgba(15,23,42,0.25)] rounded-xl p-4 md:p-6">
          <PublicSpinWheelContent />
        </div>
      </div>
    </div>
  );
}

